import { makeRequest } from '@services/requests/makeRequest';
import {
  CREATE_TICKET,
  TICKET_UPDATE,
} from '@services/requests/requestResources';

export const getHaloTicketStatuses = crmId =>
  makeRequest('GET', `${TICKET_UPDATE}/halo/${crmId}/statuses`);

export const getHaloTicketTypes = crmId =>
  makeRequest('GET', `${TICKET_UPDATE}/halo/${crmId}/types`);

export const getHaloClientsByDefaultId = crmDefaultId =>
  makeRequest('GET', `${TICKET_UPDATE}/halo/${crmDefaultId}/clients`);

export const getHaloClientsByCrmId = crmId =>
  makeRequest('GET', `${CREATE_TICKET}/${crmId}/halo/clients`);

export const getHaloSites = (crmId, clientId, useNameOnly) =>
  makeRequest(
    'GET',
    `${TICKET_UPDATE}/halo/${crmId}/sites?${
      clientId ? `clientId=${clientId}&` : ''
    }${useNameOnly ? `useNameOnly=true` : ''}`,
  );

export const getHaloUsers = (crmId, clientId, siteId, useNameOnly) =>
  makeRequest(
    'GET',
    `${TICKET_UPDATE}/halo/${crmId}/users?${
      clientId && siteId ? `clientId=${clientId}&siteId=${siteId}&` : ''
    }${useNameOnly ? `useNameOnly=true` : ''}`,
  );

export const getHaloTeams = crmId =>
  makeRequest('GET', `${TICKET_UPDATE}/halo/${crmId}/teams`);

export const editHaloTicket = (crmId, payload) =>
  makeRequest('PUT', `${TICKET_UPDATE}/halo/${crmId}`, payload);
export default {};

export const assignHaloTicketContact = (crmId, ticketId, contactId) =>
  makeRequest(
    'PUT',
    `${TICKET_UPDATE}/halo/${crmId}/tickets/${ticketId}/assignContact/${contactId}`,
  );
